import { gql } from '@apollo/client';

export default gql`
  mutation claimMissingPoints(
    $bookingReference: String!
    $membershipNumber: String!
    $ticketReference: String!
    $validateName: Boolean
    $actionBy: String
  ) {
    claimMissingPoints(
      bookingReference: $bookingReference
      membershipNumber: $membershipNumber
      ticketReference: $ticketReference
      validateName: $validateName
      actionBy: $actionBy
    ) {
      success
    }
  }
`;
